import React from 'react';
import { FileText, Download } from 'lucide-react';
export function ProductSpecs() {
  return <div className="mt-12" data-id="element-126">
      {/* Summary Banner */}
      <div className="bg-brand-charcoal text-white p-4 rounded-t-lg flex flex-wrap gap-x-8 gap-y-2 text-sm font-mono border-b-4 border-brand-red" data-id="element-127">
        <span data-id="element-128">DIA=1/8"</span>
        <span data-id="element-129">LOC=1/4"</span>
        <span data-id="element-130">OAL=1-1/2"</span>
        <span data-id="element-131">SHK=1/8"</span>
        <span data-id="element-132">CR=.005"</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-133">
        {/* Left Column */}
        <div className="space-y-8" data-id="element-134">
          <section data-id="element-135">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4 flex items-center gap-2" data-id="element-136">
              <FileText className="w-5 h-5 text-brand-darkGold" data-id="element-137" />
              General Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-138">
              <table className="w-full text-sm" data-id="element-139">
                <tbody data-id="element-140">
                  <tr className="border-b border-gray-100" data-id="element-141">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-142">
                      Brand
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-143">TITAN</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-144">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-145">
                      Series
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-146">TV42SR</td>
                  </tr>
                  <tr data-id="element-147">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-148">
                      Performance
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-149">
                      High Performance
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-150">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-151">
              Diameter Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-152">
              <table className="w-full text-sm" data-id="element-153">
                <tbody data-id="element-154">
                  <tr className="border-b border-gray-100" data-id="element-155">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-156">
                      Diameter Information
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-157">0.1250 1/8"</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-158">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-159">
                      Diameter Tolerance
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-160">+.000" -.002"</td>
                  </tr>
                  <tr data-id="element-161">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-162">
                      OD Grind
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-163">Eccentric</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-164">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-165">
              Shank Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-166">
              <table className="w-full text-sm" data-id="element-167">
                <tbody data-id="element-168">
                  <tr className="border-b border-gray-100" data-id="element-169">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-170">
                      Shank Diameter
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-171">1/8"</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-172">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-173">
                      Shank Tolerance
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-174">-.0001" -.0004"</td>
                  </tr>
                  <tr data-id="element-175">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-176">
                      Shank Type
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-177">Straight</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {/* Right Column */}
        <div className="space-y-8" data-id="element-178">
          <section data-id="element-179">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-180">
              Length Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-181">
              <table className="w-full text-sm" data-id="element-182">
                <tbody data-id="element-183">
                  <tr className="border-b border-gray-100" data-id="element-184">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-185">
                      Flute Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-186">1/4"</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-187">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-188">
                      Neck Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-189">~~~</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-190">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-191">
                      Overall Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-192">1-1/2"</td>
                  </tr>
                  <tr data-id="element-193">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-194">
                      Length Category
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-195">Stub</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-196">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-197">
              Fluting Geometry
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-198">
              <table className="w-full text-sm" data-id="element-199">
                <tbody data-id="element-200">
                  <tr className="border-b border-gray-100" data-id="element-201">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-202">
                      Number of Flutes
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-203">4</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-204">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-205">
                      Helix Angle
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-206">38 degrees</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-207">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-208">
                      Flute Index
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-209">Varied</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-210">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-211">
                      Cut
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-212">
                      Center Cutting Right Hand
                    </td>
                  </tr>
                  <tr data-id="element-213">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-214">
                      Spiral
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-215">Right Hand</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-216">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-217">
              Coating & Configuration
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-218">
              <table className="w-full text-sm" data-id="element-219">
                <tbody data-id="element-220">
                  <tr className="border-b border-gray-100" data-id="element-221">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-222">
                      Coating
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-223">AlCrN</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-224">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-225">
                      End Type
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-226">
                      Single End Corner Radius
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-227">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-228">
                      Corner Radius
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-229">.005"</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-230">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-231">
                      Corner Chamfer
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-232">~~~</td>
                  </tr>
                  <tr data-id="element-233">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-234">
                      Materials Families
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-235">
                      All (P, K, M, S, H)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>

      {/* Feeds & Speeds */}
      <section className="mt-12 bg-brand-gray border border-gray-200 rounded-lg p-6" data-id="element-236">
        <h3 className="text-xl font-bold text-brand-charcoal mb-3" data-id="element-237">
          Feeds & Speeds
        </h3>
        <p className="text-gray-600 mb-4 text-sm" data-id="element-238">
          Click on the Download link below and a PDF file will open displaying a
          printable Feeds and Speeds Chart specific for the tool selected.
        </p>
        <a href="https://www.6gtools.com/products/custom/uploaded/files/feedsandspeeds/Feeds_and_Speeds_Titan_VI-Pro_4%20Flute.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-brand-red hover:text-red-700 font-semibold transition-colors" data-id="element-239">
          <Download className="w-5 h-5" data-id="element-240" />
          Feeds and Speeds Download (0.37 MB)
        </a>
      </section>
    </div>;
}